{get_from_dict} = require('../../utils')

module.exports = (
  $scope,
  $interval,
  Api,
  settings,
  Translator,
  $uibModal
) ->

  $scope.model = {
    title: $scope.doc.title
  }

  get_identifier_for_doc = (doc) ->
    return doc.search_result or doc.id

  notifyStarredDocChange = ->
    $scope.$emit( 'Starred Doc changed' )

  $scope.moveDoc = (toStep) ->
    docId = get_identifier_for_doc($scope.doc)
    stepDocs = $scope.projectStarredDocs[$scope.doc.workflow_step]
    delete stepDocs[ docId ]

    $scope.doc.workflow_step = toStep
    $scope.projectStarredDocs[toStep] = {} if not $scope.projectStarredDocs[toStep]
    $scope.projectStarredDocs[toStep][ docId ] = $scope.doc
    $scope.doc.$update()

  $scope.deleteDoc = () ->
    docId = get_identifier_for_doc($scope.doc)
    stepDocs = $scope.projectStarredDocs[$scope.doc.workflow_step]
    $scope.doc.$delete({force: true}).then(() ->
      delete stepDocs[ docId ]
    )

  $scope.isEmpty = (obj) ->
    isEmpty = true

    for own key, value of obj
      isEmpty = false

    isEmpty

  $scope.stepList = (allSteps) ->
    (s[0] for k, s of allSteps when s[0].id isnt $scope.step.id)

  $scope.newComment = undefined

  if $scope.doc.result
    $scope.result = $scope.doc.result

  $scope.openMoveModal = ->
    moveModal = $uibModal.open
      template: require('./Partials/move-finding-model.html')
      controller: 'MoveFindingModalController'
      size: 'md'
      resolve:
        workflows: () ->
          $scope.workflows
        steps: () ->
          $scope.steps
        currentStep: () ->
          $scope.step

    moveModal.result.then ( destinationStep ) ->
      $scope.moveDoc( destinationStep.id )

  $scope.openDeleteModal = ->
    deleteModal = $uibModal.open
      template: require('./Partials/delete-finding-modal.html')
      controller: 'DeleteFindingModalController'
      size: 'md'

    deleteModal.result.then ( confirmation ) ->
      if confirmation
        $scope.deleteDoc()

  $scope.openLinkModal = ->
    linkModal = $uibModal.open
      template: require('../StarredDocumentLink/starred-doc-link-modal.html')
      controller: 'StarredDocumentLinkController'
      size: 'lg'
      resolve:
        document: () ->
          $scope.doc
        projectPermissions: () ->
          $scope.projectPermissions
        projectStarredDocs: () ->
          $scope.projectStarredDocs
        starredDocs: () ->
          $scope.starredDocs

  $scope.$watch 'doc.title', (newTitle) ->
    if !$scope.editName
      $scope.model.title = newTitle

  $scope.nameEdited = (doc) ->
    $scope.editName = false
    if $scope.model.title?.length > 0
      doc.title = $scope.model.title
      doc.$update()

  $scope.showEditName = ->
    $scope.model.title = $scope.doc.title
    $scope.editName = !$scope.editName

  $scope.editName = false
